<template>
    <div class="page-warpper indexWinner">  
        <div class="part-panel" data-index='winnerTable' v-if="winnerFcData.length>1||winnerYcData.length>1">
            
            <table  v-if="winnerYcData.length>1" >
                <tbody>
                    <tr v-if="winnerFcData.length>1&&winnerYcData.length>1">
                        <th colspan="3">原创获奖名单</th>
                    </tr>
                    <tr>
                        <template  v-for="item in tab">
                            <th  v-bind:style="{ 'width' : item.width+'%' }">{{item.name}}</th>
                        </template>                               
                    </tr>
                    <template  v-for="witem in winnerYcData">
                        <tr v-for="(val, key) in witem.data">                            	
                            <td v-if='key == 0' v-bind:rowspan="witem.data.length" v-html="val.award"></td>                                   
                            <template v-if="val.singerName">  
                                <td><a  target="_blank" v-bind:href="val.defaultUrl" >{{val.singerName}}</a></td>                                       
                                <td><a  target="_blank" v-bind:href="val.songPcUrl" >{{val.songName}}</a></td> 
                            </template>
                            <td  colspan="2" v-else>空缺</td>
                        </tr>
                    </template>                        
            
                </tbody>
            </table>
            <p class='txt'>原创二等奖及三等奖名额变动说明：评审结果由评委打分的平均分数而定，因有同分情况的存在，故为此结果，感谢大家的支持。</p>
            <table style="margin-top: 60px;" v-if="winnerFcData.length>1">
                <tbody>
                    <tr v-if="winnerFcData.length>1&&winnerYcData.length>1">
                        <th colspan="3">翻唱获奖名单</th>
                    </tr>
                    <tr>
                        <template  v-for="item in tab">
                            <th  v-bind:style="{ 'width' : item.width+'%' }">{{item.name}}</th>
                        </template>                               
                    </tr>
                    <template  v-for="witem in winnerFcData">
                        <tr v-for="(val, key) in witem.data">                            	
                            <td v-if='key == 0' v-bind:rowspan="witem.data.length" v-html="val.award"></td>                                   
                            <template v-if="val.singerName">  
                                <td><a  target="_blank" v-bind:href="val.defaultUrl" >{{val.singerName}}</a></td>                                       
                                <td><a  target="_blank" v-bind:href="val.songPcUrl" >{{val.songName}}</a></td> 
                            </template>
                            <td  colspan="2" v-else>空缺</td>
                        </tr>
                    </template>                        
            
                </tbody>
            </table>
        </div>
        <div class='no-data' v-else></div>
        <div class="part-panel part-special">
            <div  class="part-warpper" data-index='sponsor'>
                <div data-index='1'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item md" href=" http://ac.qq.com/"   target="_blank"></a>
                        <a class="part-item mg" href="javascript:void(0);" ></a>
                        <a class="part-item sing" href="http://5sing.kugou.com/index.html"   target="_blank"></a>
                        <a class="part-item kugou" href="http://www.kugou.com/"   target="_blank"></a>
                    </div>
                </div>
               
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "indexWinner",
    data() {
        return {
            winnerFcData: _fcData,
            winnerYcData: _ycData,
            tab:  tableTab,
        };
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../assets/sass/cmn.scss";
.part-panel[data-index="winnerTable"] {
    background: none;
    padding: 0;
    margin-bottom: 50px;
    table{
        width: 1000px;
        margin: 0 auto;
        border-top: 1px solid $comColor;
        border-left: 1px solid $comColor;
        border-collapse: collapse;
        border-spacing: 0;
    }
    th,td{
        border-bottom:1px solid $comColor;
        border-right:1px solid $comColor;
        padding:10px 0;
        vertical-align:middle;
        text-align:center;
        color:$comColor;
        font-size:14px;
    }
    th{
        padding:15px 0;
        font-weight:bold;
        font-size:20px;
        color: $comColor;
    }
    td a{
        text-decoration: none;
        color:inherit;
        &:hover{
            color: #ffcc19;
        }
    }
    .st-wrap {
        padding-bottom: 50px;
    }
    .txt{
        width: 1000px;
        margin: 10px auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/index-winner.vue